import { TOPBAR } from '@components/v2/layout/AppTemplate/appTemplate.consts';
import Snackbar, { SNACKBAR_MAX_WIDTH } from '@components/v2/ui/Snackbar/Snackbar';
import { useTheme } from '@mui/material';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../../modules/translation/TranslationContext';
import { useLoadingStatusSnackbar } from './hooks/useLoadingStatusSnackbar';

const VISIBLE_SNACKBARS = 3;
const SNACKBAR_DURATION_MS = 5000;
const TOP_BAR_BOTTOM = `var(${TOPBAR.bottomCssVar}, 0px)`;

const SnackbarStack = () => {
  const theme = useTheme();
  const { translate } = useTranslation();

  useLoadingStatusSnackbar();

  return (
    <Snackbar
      position="top-right"
      expand
      visibleToasts={VISIBLE_SNACKBARS}
      gap={parseFloat(theme.spacing(1.75))}
      duration={SNACKBAR_DURATION_MS}
      width={SNACKBAR_MAX_WIDTH}
      zIndex={theme.zIndex.modal + 1}
      containerAriaLabel={translate(LangEnum.GLOBAL_NOTIFICATIONS)}
      offset={{
        top: `calc(${TOP_BAR_BOTTOM} + ${theme.spacing(1)})`,
        right: theme.spacing(3),
        bottom: theme.spacing(3),
        left: theme.spacing(3),
      }}
      mobileOffset={{
        top: `calc(${TOP_BAR_BOTTOM} + ${theme.spacing(1)})`,
        right: theme.spacing(1),
        bottom: theme.spacing(1),
        left: theme.spacing(1),
      }}
    />
  );
};

export default SnackbarStack;
